<div class="modal-body">
    <div class="row mb-3">
        <div class="col text-gris-oscuro fw-bold">
            <h4 class="fw-bold mas-grande">Acciones</h4>
        </div>
        <div class="col flex-grow-0 my-auto">
            <button type="button" class="btn-close" aria-label="Close" (click)="cancelar()"></button>
        </div>
    </div>
    <table class="table table-striped">
        <thead>
            <tr>
                <th scope="col">Tipo</th>
                <th scope="col">Objetivo</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let accion of acciones; trackBy: trackById">
                <th>{{ accion.type | nombreTipoAccion }}</th>
                <td>{{ accion | objetivoAccion }}</td>
                <td>
                    <app-svg-icon icon="trash" class="seleccionable" (click)="borrar(accion)"></app-svg-icon>
                </td>
            </tr>
            <tr class="seleccionable" (click)="abrirFormulario()">
                <th scope="row">Haga click para crear una nueva</th>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>
    <div class="row" [(ngbCollapse)]="agregarColapsado">
        <hr />
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <div class="mb-3">
                        <label class="form-label" for="cliente">Accion</label>
                        <ng-select [items]="tiposAcciones" [clearable]="false" placeholder="Cliente" bindLabel="valor"
                            [inputAttrs]="{ id: 'cliente' }" [formControl]="accionTipoControl" bindValue="clave">
                        </ng-select>
                    </div>
                </div>
            </div>
            <form *ngIf="formGroupAccion != null" [formGroup]="formGroupAccion">
                <ng-container *ngIf="accionTipoControl.value === TipoAccionesEnum.ADD_USER_TO_CAMPAIGN ||
                    accionTipoControl.value === TipoAccionesEnum.REMOVE_USER_FROM_CAMPAIGN">
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label class="form-label" for="investigacion">Investigacion</label>
                                <ng-select [items]="$any(investigacionesBuscadas$ | async)" [clearable]="false"
                                    [hideSelected]="true" [typeahead]="investigacionBuscarInput$" bindLabel="nombre"
                                    formControlName="investigacion" [inputAttrs]="{ id: 'investigacion'}">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.nombre}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label class="form-label" for="grupo">Grupo</label>
                                <ng-select [items]="grupos" bindLabel="nombre" formControlName="grupo"
                                    [inputAttrs]="{ id: 'grupo'}" [clearable]="false">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.nombre}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="accionTipoControl.value === TipoAccionesEnum.ADD_TAG_TO_USER ||
                    accionTipoControl.value === TipoAccionesEnum.REMOVE_TAG_FROM_USER">
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label class="form-label" for="etiqueta">Etiqueta</label>
                                <ng-select [items]="etiquetas" [clearable]="false" bindLabel="valor"
                                    formControlName="etiqueta" [inputAttrs]="{ id: 'etiqueta'}">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.valor}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </form>
        </div>
        <div class="col-12">
            <div class="row solo-botones">
                <div class="col-12 text-end">
                    <button class="btn btn-outline-secondary" (click)="cerrarFormulario()">Cancelar</button>
                    <button class="btn btn-primary" (click)="guardar()" [disabled]="formGroupAccion?.invalid">Guardar</button>
                </div>
            </div>
        </div>
    </div>
</div>
